/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as zod from 'zod';


/**
 * Retrieves vehicle information from VIPS and the vehicle health report URI. Works independently of contract availability — can be called even when no contract exists for the VIN.
 * @summary Gets vehicle details and health report for a VIN
 */
export const getVinDetailPathVinMin = 8;
export const getVinDetailPathVinMax = 17;


export const getVinDetailPathVinRegExp = new RegExp('^[A-Z0-9]{8,17}$');


export const GetVinDetailParams = zod.object({
  "vin": zod.string().min(getVinDetailPathVinMin).max(getVinDetailPathVinMax).regex(getVinDetailPathVinRegExp).describe('Full VIN (up to 17 characters; legacy VINs may be shorter) or chassis suffix (last 8 characters)')
})

export const getVinDetailResponseVinMin = 8;
export const getVinDetailResponseVinMax = 17;

export const getVinDetailResponseMakeMax = 100;

export const getVinDetailResponseModelFamilyMax = 100;

export const getVinDetailResponseModelYearMin = 0;

export const getVinDetailResponseSellingDealerIdRegExp = new RegExp('^[0-9]{9}$');


export const GetVinDetailResponse = zod.object({
  "vin": zod.string().min(getVinDetailResponseVinMin).max(getVinDetailResponseVinMax),
  "make": zod.string().min(1).max(getVinDetailResponseMakeMax),
  "modelFamily": zod.string().min(1).max(getVinDetailResponseModelFamilyMax),
  "modelYear": zod.number().min(getVinDetailResponseModelYearMin),
  "deliveryDate": zod.iso.date().nullish(),
  "modelCode": zod.string().nullish(),
  "modelCodeDescription": zod.string().nullish(),
  "series": zod.string().nullish(),
  "engineSerialNumber": zod.string().nullish(),
  "sellingDealerAccount": zod.string().nullish(),
  "sellingDealerLocation": zod.string().nullish(),
  "sellingDealerId": zod.string().regex(getVinDetailResponseSellingDealerIdRegExp).nullish().describe('9-digit dealer id composed as 6-digit account + 3-digit location.'),
  "customerName": zod.string().nullish(),
  "lastRecordedOdometer": zod.number().nullish(),
  "lastRecordedEngineHours": zod.number().nullish(),
  "lastRecordedAt": zod.iso.datetime({"offset":true}).nullish(),
  "vehicleHealthReportUri": zod.string().nullish(),
  "modelFamilyDescription": zod.string().nullish(),
  "modelSeriesCode": zod.string().nullish(),
  "axleConfiguration": zod.string().nullish(),
  "cabConfiguration": zod.string().nullish(),
  "application": zod.string().nullish(),
  "cabType": zod.string().nullish(),
  "engineBrake": zod.string().nullish(),
  "engineManufacturer": zod.string().nullish(),
  "engineModel": zod.string().nullish(),
  "frontAxleModel": zod.string().nullish(),
  "frontAxleManufacturer": zod.string().nullish(),
  "rearAxleManufacturer": zod.string().nullish(),
  "rearAxleModel": zod.string().nullish(),
  "rearAxle": zod.string().nullish(),
  "suspensionFront": zod.string().nullish(),
  "suspensionRear": zod.string().nullish(),
  "transmission": zod.string().nullish(),
  "transmissionManufacturer": zod.string().nullish(),
  "transmissionModel": zod.string().nullish(),
  "engineFeatureCode": zod.string().nullish(),
  "engineFeatureDescription": zod.string().nullish(),
  "horsepower": zod.string().nullish(),
  "warrantyStartDate": zod.iso.date().nullish(),
  "origWarrantyOdometer": zod.string().nullish(),
  "origWarrantyOdometerType": zod.string().nullish(),
  "origWarrantyEngineHours": zod.string().nullish(),
  "ctsDocument": zod.string().nullish(),
  "vehicleControlCode": zod.string().nullish(),
  "carbCompliantIndicator": zod.string().nullish(),
  "carbCompliantFeature": zod.string().nullish(),
  "customerBuildDate": zod.iso.date().nullish(),
  "customerSecondaryName": zod.string().nullish(),
  "customerAddressLine1": zod.string().nullish(),
  "customerAddressLine2": zod.string().nullish(),
  "customerCity": zod.string().nullish(),
  "customerState": zod.string().nullish(),
  "customerZipCode": zod.string().nullish(),
  "customerLastChangedDate": zod.iso.date().nullish()
})

